import { Navigate, Outlet, useLocation } from "react-router-dom";

import { usePlatformAuth } from "../hooks/usePlatformAuth";

export function PlatformProtectedRoute() {
  const location = useLocation();

  const {
    isAuthenticated,
    isLoading,
  } = usePlatformAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 px-6">
        <div className="text-center">
          <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-indigo-600" />

          <p className="mt-4 text-sm font-medium text-slate-600">
            Restoring Platform Console session...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
        }}
      />
    );
  }

  return <Outlet />;
}
